// extracted by mini-css-extract-plugin
export var influence = "style-module--influence--fd366";
export var influence__content = "style-module--influence__content--ae30f";
export var influence__contentText = "style-module--influence__content-text--315b7";
export var influence__image = "style-module--influence__image--4e61c";
export var influence__process = "style-module--influence__process--108e9";
export var influence__processBlock = "style-module--influence__process-block--461d1";
export var influence__processBlocks = "style-module--influence__process-blocks--71fdc";
export var influence__wrapper = "style-module--influence__wrapper--105d0";